import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, unit, icon, trend, trendValue, color = 'cyan', subtitle }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const duration = 1500;
    const steps = 60;
    const increment = value / steps;
    let current = 0;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= value) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value]);

  const colorClasses = {
    cyan: 'text-accent-cyan border-accent-cyan/20 bg-accent-cyan/10',
    blue: 'text-accent-blue border-accent-blue/20 bg-accent-blue/10',
    purple: 'text-accent-purple border-accent-purple/20 bg-accent-purple/10',
    pink: 'text-accent-pink border-accent-pink/20 bg-accent-pink/10'
  };

  const glowColors = {
    cyan: 'glow-subtle',
    blue: 'shadow-[0_0_10px_rgba(14,165,233,0.3)]',
    purple: 'shadow-[0_0_10px_rgba(168,85,247,0.3)]',
    pink: 'shadow-[0_0_10px_rgba(236,72,153,0.3)]'
  };

  return (
    <div className={`card hover:scale-[1.02] ${glowColors?.[color]}`}>
      <div className="flex items-start justify-between mb-4">
        <div className={`flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl border ${colorClasses?.[color]}`}>
          <Icon 
            name={icon} 
            size={24} 
            color={`var(--color-accent-${color})`}
          />
        </div>
        
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-lg ${trend === 'up' ? 'bg-success/20 text-success' : 'bg-error/20 text-error'}`}>
            <Icon 
              name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
              size={14}
            />
            <span className="text-xs font-data">{trendValue}</span>
          </div>
        )}
      </div>
      <h3 className="text-sm md:text-base font-caption text-muted-foreground mb-2">
        {title}
      </h3>
      <div className="flex items-baseline gap-2">
        <span className={`text-3xl md:text-4xl lg:text-5xl font-bold font-data ${colorClasses?.[color]?.split(' ')?.[0]}`}>
          {displayValue?.toLocaleString('en-US')}
        </span>
        {unit && (
          <span className="text-lg md:text-xl font-caption text-muted-foreground">
            {unit}
          </span>
        )}
      </div>
      {subtitle && (
        <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
      )}
    </div>
  );
};

export default StatsCard;